import { useState } from 'react';

const galleryImages = [
  {
    id: 1,
    url: 'https://public.readdy.ai/ai/img_res/b6bfb7b06cbeadeb6dbecf9ecb190a0f.jpg',
    title: 'Production Facility',
    category: 'Manufacturing'
  },
  {
    id: 2,
    url: 'https://readdy.ai/api/search-image?query=quality%20control%20laboratory%20testing%20area%20with%20scientists%20examining%20spa%20salon%20medical%20products%20modern%20equipment%20microscopes%20test%20tubes%20clean%20white%20environment%20professional%20pharmaceutical%20lab&width=800&height=600&seq=factory2&orientation=landscape',
    title: 'Quality Control Lab',
    category: 'Testing'
  },
  {
    id: 3,
    url: 'https://readdy.ai/api/search-image?query=warehouse%20storage%20facility%20with%20organized%20shelves%20stacked%20boxes%20spa%20salon%20medical%20products%20inventory%20management%20clean%20spacious%20industrial%20warehouse%20bright%20lighting%20professional%20logistics&width=800&height=600&seq=factory3&orientation=landscape',
    title: 'Warehouse Storage',
    category: 'Logistics'
  },
  {
    id: 4,
    url: 'https://readdy.ai/api/search-image?query=packaging%20department%20workers%20packing%20spa%20salon%20medical%20products%20into%20boxes%20assembly%20line%20modern%20equipment%20clean%20organized%20workspace%20professional%20industrial%20setting%20bright%20environment&width=800&height=600&seq=factory4&orientation=landscape',
    title: 'Packaging Department',
    category: 'Packaging'
  },
  {
    id: 5,
    url: 'https://readdy.ai/api/search-image?query=research%20and%20development%20laboratory%20scientists%20developing%20new%20spa%20salon%20medical%20products%20modern%20equipment%20computers%20testing%20samples%20clean%20white%20lab%20coats%20professional%20pharmaceutical%20research&width=800&height=600&seq=factory5&orientation=landscape',
    title: 'R&D Laboratory',
    category: 'Research'
  },
  {
    id: 6,
    url: 'https://readdy.ai/api/search-image?query=factory%20exterior%20modern%20pharmaceutical%20manufacturing%20building%20large%20industrial%20facility%20clean%20architecture%20blue%20sky%20professional%20corporate%20headquarters%20spa%20salon%20medical%20products%20company&width=800&height=600&seq=factory6&orientation=landscape',
    title: 'Factory Exterior',
    category: 'Facility'
  },
  {
    id: 7,
    url: 'https://readdy.ai/api/search-image?query=automated%20production%20machinery%20manufacturing%20spa%20salon%20medical%20products%20robotic%20arms%20conveyor%20belts%20modern%20technology%20clean%20industrial%20equipment%20bright%20lighting%20professional%20automation&width=800&height=600&seq=factory7&orientation=landscape',
    title: 'Automated Production',
    category: 'Technology'
  },
  {
    id: 8,
    url: 'https://readdy.ai/api/search-image?query=team%20meeting%20conference%20room%20professionals%20discussing%20spa%20salon%20medical%20products%20business%20strategy%20modern%20office%20presentation%20screens%20collaborative%20workspace%20bright%20professional%20environment&width=800&height=600&seq=factory8&orientation=landscape',
    title: 'Team Collaboration',
    category: 'Management'
  }
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<typeof galleryImages[0] | null>(null);
  const [filter, setFilter] = useState('All');

  const categories = ['All', ...Array.from(new Set(galleryImages.map(img => img.category)))];

  const filteredImages = filter === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Factory <span className="text-teal-600">Gallery</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Take a virtual tour of our state-of-the-art manufacturing facilities and quality control processes
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                filter === category
                  ? 'bg-teal-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-teal-50 hover:text-teal-600'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              onClick={() => setSelectedImage(image)}
              className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <div className="relative w-full h-64">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-base font-bold mb-1">{image.title}</h3>
                <p className="text-xs text-teal-300">{image.category}</p>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-teal-600 text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            onClick={() => setSelectedImage(null)}
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-all duration-300 cursor-pointer"
              aria-label="Close"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            <div className="max-w-5xl w-full">
              <div className="relative w-full h-[70vh]">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  className="w-full h-full object-contain"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <div className="text-center mt-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
                <p className="text-base text-teal-400">{selectedImage.category}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
